import { StatePlaceholder } from '../../../cdl/StatePlaceholder/StatePlaceholder';
import { translate } from '../../../common/helpers/translate.helper';
import { IconSearch } from '../../../common/icons/cdl/Search';
import { Box } from '../../../common/ui/Box';

export const NoSearchResultsState = () => {
    return (
        <Box marginTop="124px" display="flex" justifyContent="center">
            <StatePlaceholder
                Icon={IconSearch}
                title={translate('members.noResults.title')}
                description={translate('members.noResults.description')}
            />
        </Box>
    );
};
